export type CalendarMountMode = 'doc' | 'edgeless' | 'fullscreen';

const DATABASE_FULLSCREEN_SURFACE_SELECTOR = [
  '[data-database-isolated-surface="true"]',
  'database-fullscreen-editor',
  '.database-fullscreen-viewport',
].join(',');

export function detectCalendarMountMode(el: HTMLElement): CalendarMountMode {
  let current: Element | null = el;
  while (current && current !== document.body) {
    const tag = current.tagName?.toLowerCase();
    if (tag === 'affine-edgeless-database') return 'edgeless';
    if (tag === 'affine-database') {
      return current.getAttribute('data-streamlain-database-surface') ===
        'fullscreen' || current.closest(DATABASE_FULLSCREEN_SURFACE_SELECTOR)
        ? 'fullscreen'
        : 'doc';
    }
    current = current.parentElement;
  }
  return 'doc';
}
